import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { PostsType } from '../../../../../types/posts';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';

const mapStateToProps = (state: AppState) => {
  const hasNoJournals = !streamSelectors.getItems(
    state,
    getPostsDeviationsStreamId({ type: PostsType.JOURNALS })
  ).length;
  const hasNoPolls = !streamSelectors.getItems(
    state,
    getPostsDeviationsStreamId({ type: PostsType.POLLS })
  ).length;
  const hasNoStatuses = !streamSelectors.getItems(
    state,
    getPostsDeviationsStreamId({ type: PostsType.STATUSES })
  ).length;
  const hasNoDrafts = !streamSelectors.getItems(
    state,
    getPostsDeviationsStreamId({ type: PostsType.DRAFTS })
  ).length;

  return {
    hasNoPosts: hasNoJournals && hasNoPolls && hasNoStatuses && hasNoDrafts,
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
